import { ChartBarIcon } from '@phosphor-icons/react';
import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { requireModules } from '../../route';
import { Route as procurementFiltersRoute } from '../filters/route';
import { replenishmentDetailSearchSchema } from './replenishmentDetailSearch';

const ReplenishmentDetailPage = lazyRouteComponent(
  () => import('./ReplenishmentDetailPage'),
  'ReplenishmentDetailPage',
);

export const Route = createRoute({
  // Under the procurement filter route, so the shared filters survive a trip
  // here from Forecast Detail and back.
  getParentRoute: () => procurementFiltersRoute,
  path: '/procurement/replenishment-detail',
  validateSearch: replenishmentDetailSearchSchema,
  staticData: {
    app: {
      nav: {
        label: msg('Replenishment detail', {
          context: 'sidebar nav label, Procurement section',
        }),
        icon: <ChartBarIcon className="h-4 w-4" weight="fill" />,
        group: 'Procurement',
        order: 41,
        groupOrder: 30,
        // Reached from Forecast Detail with one SKU at one location in mind.
        defaultHidden: true,
      },
      performance: {
        pageId: 'replenishment-detail',
        readiness: 'route-rendered',
      },
      access: {
        modulesAnyOf: [ProductModule.PROCUREMENT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Inventory }],
      },
    },
  },
  component: ReplenishmentDetailPage,
  loader: () => ({
    crumb: msg('Replenishment detail', { context: 'page breadcrumb' }),
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT],
    });
  },
});
